import { Field, useFormikContext } from 'formik';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormikCheckbox, FormikMultiSelect } from '../../../../../components/prime-formik';

const SuperMatchWorkplaceDetailsRemoteOnlyInput = ({ countryOptions }) => {
  const { values, setFieldValue, handleChange } = useFormikContext();

  return (
    <div className="margin-bottom-0-5">
      <FormattedMessage
        id="account.super-profiles.new.workplace-location.type.remote-only"
        defaultMessage="Work remote only"
        tagName="label"
      >
        {(text) => (
          <Field
            name="workplaceDetailsType"
            checked={values.workplaceDetailsType === 'REMOTE_ONLY'}
            component={FormikCheckbox}
            setFieldValue={() => {
              setFieldValue('workplaceDetailsType', 'REMOTE_ONLY');
            }}
            labelText={text}
          />
        )}
      </FormattedMessage>
      {values.workplaceDetailsType === 'REMOTE_ONLY' && (
        <div className="mt10 margin-bottom-0-5 margin-left-1-5">
          <div className="margin-bottom-0-5">
            <FormattedMessage
              id="account.super-profiles.new.workplace-location.remote-only.from-any-country"
              defaultMessage="From any country"
              tagName="label"
            >
              {(text) => (
                <Field
                  name="workplaceDetailsRemoteOnlyFromAnyCountry"
                  component={FormikCheckbox}
                  setFieldValue={setFieldValue}
                  disabled={values.workplaceDetailsType !== 'REMOTE_ONLY'}
                  labelText={text}
                />
              )}
            </FormattedMessage>
          </div>
          <div className="flex-space-between">
            <FormattedMessage
              id="account.super-profiles.new.workplace-location.select-country"
              defaultMessage="Select country"
            >
              {(text) => <label className="field-label">{text}</label>}
            </FormattedMessage>
            <FormattedMessage id="select" defaultMessage="Select">
              {(text) => (
                <Field
                  name="workplaceDetailsRemoteOnlyCountries"
                  component={FormikMultiSelect}
                  options={countryOptions}
                  filter
                  filterBy="label,value"
                  className="right width-140"
                  onChange={handleChange}
                  placeholder={`-- ${text} --`}
                  disabled={
                    values.workplaceDetailsType !== 'REMOTE_ONLY' ||
                    values.workplaceDetailsRemoteOnlyFromAnyCountry === true
                  }
                />
              )}
            </FormattedMessage>
          </div>
        </div>
      )}
    </div>
  );
};

export default SuperMatchWorkplaceDetailsRemoteOnlyInput;
